import { Outlet, Link } from 'react-router-dom';
import { Dumbbell, Users, Building, Clock, BarChart3 } from 'lucide-react';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 bg-primary-600 p-12 flex-col justify-between relative overflow-hidden">
        {/* Decorative animated background blobs */}
        <div className="absolute top-20 right-20 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-pulse-soft" />
        <div className="absolute bottom-20 left-10 w-48 h-48 bg-primary-400/20 rounded-full blur-3xl animate-pulse-soft" />

        <div className="flex items-center gap-2 relative z-10">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
            <Dumbbell className="w-6 h-6 text-primary-600" />
          </div>
          <span className="text-2xl font-bold text-white">FitManage</span>
        </div>
        <div className="text-white max-w-md relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Professional Fitness Management Platform
          </h1>
          <p className="text-lg text-primary-100 mb-8">
            Manage organizations, venues, queues, and member experiences with our comprehensive platform built for fitness professionals.
          </p>
          <div className="space-y-4 stagger-children">
            <FeatureItem icon={Users} text="Multi-organization management" />
            <FeatureItem icon={Building} text="Venue & facility scheduling" />
            <FeatureItem icon={Clock} text="Smart queue management" />
            <FeatureItem icon={BarChart3} text="Real-time analytics & insights" />
          </div>
        </div>
        <div className="text-primary-200 text-sm relative z-10">
          © {new Date().getFullYear()} FitManage. All rights reserved.
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-gray-50 dark:bg-gray-900">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-2 mb-8 justify-center">
            <div className="w-10 h-10 bg-primary-600 rounded-xl flex items-center justify-center">
              <Dumbbell className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-gray-900 dark:text-white">FitManage</span>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 animate-slide-up">
            <Outlet />
          </div>

          <p className="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
            By continuing, you agree to our{' '}
            <Link to="/terms" className="text-primary-600 hover:underline">Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy" className="text-primary-600 hover:underline">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

function FeatureItem({ icon: Icon, text }: { icon: React.ComponentType<{ className?: string }>; text: string }) {
  return (
    <div className="flex items-center gap-3 text-primary-100 animate-slide-up">
      <Icon className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
